/** Returns true for live exam routes that use the dark stage shell (/test, /d_test). */
export function isExamStageRoute(pathname: string): boolean {
  return pathname.endsWith('/test') || pathname.endsWith('/d_test');
}

// Sets html/body/#root backgrounds from computed CSS theme tokens during exam transitions (avoids bright flashes).
export function applyExamShellBackground(mode: 'admin' | 'stage'): void {
  const token = mode === 'admin' ? '--env-bg-admin' : '--env-bg-stage';
  const color = getComputedStyle(document.documentElement).getPropertyValue(token).trim() || '#404040';
  document.documentElement.style.backgroundColor = color;
  document.body.style.backgroundColor = color;
  const root = document.getElementById('root');
  if (root) {
    root.style.backgroundColor = color;
  }
}
